// Global Imports
import * as React from "react";
// Controls
import { IconIndicator } from "./IconIndicator";
// Style
import { useTheme } from "@fluentui/react";
import { chatSmallIconProps } from "../../../icons/icons.styles";
import { getBaseIndicatorStyles } from "./Indicators.styles";
/**
 * Conversation Indicator component that renders an icon indicating a conversation exists on the task
 */ export const ConversationIndicator = (props)=>{
    const theme = useTheme();
    const styles = getBaseIndicatorStyles(theme);
    return /*#__PURE__*/ React.createElement("div", {
        className: "conversation indicator",
        title: props.ariaLabel
    }, /*#__PURE__*/ React.createElement(IconIndicator, {
        ...props,
        ariaLabel: props.ariaLabel,
        iconProps: chatSmallIconProps,
        styles: styles
    }));
};
